import { Button as NButton, type ButtonProps as NButtonProps } from '@natera/material/lib/button'
import { useNavigate } from 'react-router'
import { cn } from '~/shared/lib/cn'
import './button.scss'

// Intentionally removing outlined prop, since we're not allowed using it in OptiStream
interface ButtonProps extends Omit<NButtonProps, 'outlined'> {
  to?: string
  size?: 'small' | 'medium' | 'large'
  tonal?: boolean
}

export function Button({ className, size, tonal, to, onClick, type, ...rest }: ButtonProps) {
  const navigate = useNavigate()

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (to && (e.metaKey || e.ctrlKey || e.button === 1)) {
      window.open(to, '_blank')
    } else if (to) {
      navigate(to)
    } else {
      onClick?.(e)
    }
  }

  return (
    <NButton
      {...rest}
      type={type ?? 'button'}
      onClick={handleClick}
      ripple
      className={cn(
        'c-button',
        'whitespace-nowrap',
        {
          'c-button--small': size === 'small',
          'c-button--medium': size === 'medium',
          'c-button--large': size === 'large',
          'c-button--tonal': tonal,
          'c-button--icon': !rest.children,
        },
        className,
      )}
    />
  )
}
